"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderingAppHandlerWeb = void 0;
const React = require("react");
const OrderingAppConfig_1 = require("../../models/OrderingAppConfig");
const AppHandlerWeb_1 = require("../../../../../components/base/handlers/AppHandlerWeb");
const retailClientFactory_1 = require("../../client/retailClientFactory");
const retailClientFactory_2 = require("../../mockClient/retailClientFactory");
/**
 * Top most handler passing config and Spg client setup to platform specific
 * handler
 *
 * The Client and Config providers are setup in the AppHandlerWeb via the onInit callback
 */
const OrderingAppHandlerWeb = ({ children, configOverride }) => {
    const handleOnInit = (platformConfig) => {
        // merge and validate configs
        const defaults = new OrderingAppConfig_1.OrderingAppConfig();
        const config = OrderingAppConfig_1.OrderingAppConfig.unserialize(Object.assign(Object.assign(Object.assign({}, defaults), platformConfig), configOverride));
        config.validate();
        // setup appropriate client
        const client = config.useRealClient
            ? (0, retailClientFactory_1.retailClientFactory)(config.servicesUrl)
            : (0, retailClientFactory_2.mockRetailClientFactory)();
        return [config, client];
    };
    return React.createElement(AppHandlerWeb_1.AppHandlerWeb, { onInit: handleOnInit }, children);
};
exports.OrderingAppHandlerWeb = OrderingAppHandlerWeb;
//# sourceMappingURL=index.js.map